import { useMemo } from "react";
import { Box, Stack } from "@mui/material";
import CustomTooltip from "components/shared/tooltip";


const TruncateList = ({
    data,
    limit = 3,
    transform = (data) => data,
    renderVisible = (data) => data,
    renderHidden = (data) => data,
    defaultValue = '',
    showTooltip = true,
    className = '',
    sx = {}
}) => {
    const { shownData, hiddenData } = useMemo(() => {
        const transformedData = (data ?? []).map(transform) ?? [];
        return {
            shownData: transformedData.slice(0, limit),
            hiddenData: transformedData.slice(limit),
        };
    }, [data]);

    const hiddenCount = hiddenData?.length ?? 0;

    return <Stack className={className} direction={'row'} sx={sx} style={{ textWrap: 'nowrap' }} spacing={1} flexWrap='nowrap'>
        {data?.length === 0 ? defaultValue :
            <>
                <Box className='TruncateListVisibleItems'>
                    {shownData.map(renderVisible)}
                </Box>
                <Box>
                    <CustomTooltip
                        disableHoverListener={!showTooltip}
                        title={hiddenData.map(renderHidden)}
                        arrow={true}
                        placement={'top-start'}
                    >
                        <Box className='TruncateListHiddenCount'>
                            {hiddenCount === 0 ? '' : `+${hiddenCount}`}
                        </Box>
                    </CustomTooltip>
                </Box>
            </>
        }
    </Stack>
}

export default TruncateList;
